var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
export var PackingProgress = function (_a) {
    var packed = _a.packed, total = _a.total;
    var t = useTranslation().t;
    var progressPercent = useMemo(function () {
        if (total <= 0)
            return 0;
        return Math.max(0, Math.min(100, Math.round((packed / total) * 100)));
    }, [packed, total]);
    return (_jsxs("div", __assign({ className: 'rounded-lg px-3 py-2' }, { children: [_jsxs("div", __assign({ className: 'mb-1 flex items-center justify-between text-[11px] font-semibold text-gray-600' }, { children: [_jsx("span", { children: t('Progress') }, void 0), _jsxs("span", { children: [packed, "/", total, " (", progressPercent, "%)"] }, void 0)] }), void 0), _jsx("div", __assign({ className: 'h-1.5 w-full overflow-hidden rounded-full bg-gray-200' }, { children: _jsx("div", { className: 'h-full rounded-full bg-primary transition-all duration-300', style: { width: progressPercent + "%" } }, void 0) }), void 0)] }), void 0));
};
export default PackingProgress;
